import { render, staticRenderFns } from "./ClientAccounts.vue?vue&type=template&id=35f60eb4&"
import script from "./ClientAccounts.vue?vue&type=script&lang=js&"
export * from "./ClientAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccounts.vue?vue&type=style&index=0&id=35f60eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports